import api from './api';

export const enrollCourse = (courseId) =>
    api.post(`/courses/${courseId}/enroll`);

export const getMyCourses = () =>
    api.get('/my-courses');

export const learnCourse = (courseId) =>
    api.get(`/courses/${courseId}/learn`);

export const completeLesson = (lessonId) =>
    api.post(`/lessons/${lessonId}/complete`);

export const getMyProgress = () =>
    api.get('/my-progress');

// Tests
export const submitTest = (testId, data) =>
    api.post(`/tests/${testId}/submit`, data);

export const getTestResults = (testId) =>
    api.get(`/tests/${testId}/my-results`);
